import "./DeleteSectionModal.css";

import { overlay } from "overlay-kit";
import { FC, useState } from "react";

import { serverDisconnectSection } from "api/api-server-actions";
import { t } from "i18n/i18n";
import { ConfirmationDialog } from "mds/components/ConfirmationDialog";
import { LegacyTextField } from "mds/components/LegacyTextField";
import { useAppSelector } from "store/index";
import { selectCurrentCourseCode, selectLmsType } from "store/selectors";
import { toastSuccessMessage } from "utils/alerts";

export const showDisconnectConfirmationModal = ({ sectionId }: { sectionId: string }) =>
  overlay.openAsync<boolean>(({ isOpen, close }) => (
    <DisconnectSectionModal
      open={isOpen}
      sectionId={sectionId}
      onClose={close}
      onConfirm={() => {}}
    />
  ));

type DisconnectSectionModalProps = {
  sectionId: string;
  open: boolean;
  onClose: (confirmed: boolean) => void;
  onConfirm: () => void;
};

// eslint-disable-next-line react-refresh/only-export-components
const DisconnectSectionModal: FC<DisconnectSectionModalProps> = ({
  sectionId,
  open,
  onClose,
  onConfirm,
}) => {
  const lmsType = useAppSelector(selectLmsType);
  const courseCode = useAppSelector(selectCurrentCourseCode);
  const buttonText = t("confirm_disconnect_modal.button_text");
  const [deletePagesAndAssessments, setDeletePagesAndAssessments] = useState<boolean>(true);
  const [disableDisconnect, setDisableDisconnect] = useState<boolean>(true);

  const handleCourseConfirmationCheck = (text: string) => {
    setDisableDisconnect(text !== courseCode);
  };

  const handleDisconnect = async () => {
    await serverDisconnectSection(sectionId, deletePagesAndAssessments);
    toastSuccessMessage(t("success.toasts.disconnect_section_success"));
    onConfirm();
  };

  return (
    <ConfirmationDialog
      confirmButtonDisabled={disableDisconnect}
      confirmButtonKind="caution"
      confirmButtonText={buttonText}
      open={open}
      title={t("confirm_disconnect_modal.disconnect_item", { lms: lmsType })}
      onClose={onClose}
      onConfirm={handleDisconnect}
    >
      <div className="section-delete-modal flex flex-col items-start gap-8">
        <div className="section-delete-warning">
          {t("confirm_disconnect_modal.disconnect_section_warning", { lms: lmsType })}
        </div>

        <label className="flex items-start gap-2">
          <input
            checked={deletePagesAndAssessments}
            className="mt-[0.1875rem]"
            type="checkbox"
            onChange={() => setDeletePagesAndAssessments(!deletePagesAndAssessments)}
          />
          <div>{t("confirm_disconnect_modal.clear_content_checkbox_text", { lms: lmsType })}</div>
        </label>
        <div className="flex flex-col gap-2">
          <label htmlFor="course-code">{t("section_list_panel.course_confirm_label")}</label>

          <LegacyTextField
            id="course-code"
            placeholder={t("section_list_panel.course_placeholder")}
            isEditing
            onChange={(event) => handleCourseConfirmationCheck(event.target.value)}
          />
        </div>
      </div>
    </ConfirmationDialog>
  );
};
